module.exports = __webpack_public_path__ + "img/logo-sm-light.3e526a43.png";